import { Link, useParams } from "react-router-dom";
import useSeo from "@/hooks/useSeo";
import { useConfig } from "@/hooks/useConfig";
import { POLICIES, textToSections } from "@/pages/policies";
import NotFound from "@/pages/NotFound";

export default function Policy() {
  const { policy } = useParams();
  const p = POLICIES[policy];
  const cfg = useConfig();
  const custom = p && cfg[`policy_${policy}`];
  const sections = custom ? textToSections(custom) : p?.sections;
  useSeo(p ? p.title : "Policy", p ? `${p.title} for bookings at The Ananta Udaipur and The Ananta Hotels.` : undefined);
  if (!p) return <NotFound />;
  return (
    <section className="container-x py-16 sm:py-24 grid lg:grid-cols-12 gap-12">
      <aside className="lg:col-span-3 order-2 lg:order-1">
        <p className="eyebrow text-[#6b6b6b] mb-4">Policies</p>
        {Object.entries(POLICIES).map(([k, v]) => (
          <Link key={k} to={`/policies/${k}`} data-testid={`policy-nav-${k}`} className={`block py-2 text-sm ${k === policy ? "text-[#1E3B2E] font-medium" : "text-[#6b6b6b] hover:text-[#1E3B2E]"}`}>{v.title}</Link>
        ))}
      </aside>
      <article className="lg:col-span-9 order-1 lg:order-2 prose-policy max-w-3xl" data-testid={`policy-${policy}`}>
        <p className="eyebrow text-[#C28B5E]">The Ananta Hotels</p>
        <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl text-[#1E3B2E] tracking-tight">{p.title}</h1>
        {sections.map(([h, paras], n) => (
          <div key={`${h}-${n}`}>
            {h && <h2>{h}</h2>}
            {paras.map((t) => <p key={t} className="mb-3">{t}</p>)}
          </div>
        ))}
      </article>
    </section>
  );
}
